import styled from 'styled-components'

type TSeparatorProps = {
  $mb?: number
  $mt?: number
}

export const SeparatorContainer = styled.div<TSeparatorProps>`
  height: 0.5px;
  background-color: ${({ theme }) => theme.colors.text};
  margin-bottom: ${({ $mb }) => ($mb ? `${$mb}px` : '0px')};
  margin-top: ${({ $mt }) => ($mt ? `${$mt}px` : '0px')};
`
